import {buildTagViewModel} from './SessionHelper';

export const TAG_SCOPE = {
    EXTERNAL: 'EXTERNAL',
    INTERNAL: 'INTERNAL',
};

export const TAG_TYPE = {
    BEHAVIOR: 'BEHAVIOR',
    COMMUNICATION: 'COMMUNICATION',
    ENVIRONMENT: 'ENVIRONMENT',
};

export const groupMasterTagsByCategory = (tagsData) => {
    if (!tagsData || tagsData.length === 0) {
        return {};
    }

    const groupedTags = {};

    tagsData.forEach(tag => {
        const baseTag = buildTagViewModel(tag);
        const category = baseTag.category;

        const transformedTag = {
            ...baseTag,
            category: category
        };

        if (!groupedTags[category]) {
            groupedTags[category] = [];
        }
        groupedTags[category].push(transformedTag);
    });

    return groupedTags;
};

export const buildHierarchicalTagRows = (groupedTags) => {
    const categoryRows = [];
    const tagRows = [];

    Object.keys(groupedTags).forEach(categoryKey => {
        if (groupedTags[categoryKey].length > 0) {
            categoryRows.push({
                id: categoryKey,
                category: categoryKey,
                isCategory: true,
                hierarchy: [categoryKey]
            });

            tagRows.push(
                ...groupedTags[categoryKey].map(tag => ({
                    ...tag,
                    hierarchy: [categoryKey, tag.label]
                }))
            );
        }
    });

    return [...categoryRows, ...tagRows];
};
